import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './BlogList.css';

const VideoGallery = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Replace with your channel ID and API key
  const channelId = "UCalh77UMP-7Va42ahoFHnZA"; // Replace with your actual channel ID
  const apiKey = "AIzaSyB7nGDTc061wCpnslx6MzzJO5mjcPkUAO8";

  const handleYouTubeClick = (e) => {
    // Save current scroll position to sessionStorage
    sessionStorage.setItem('scrollPosition', window.scrollY);

    // Save reference to the section if you want to specifically return to it
    sessionStorage.setItem('lastSection', 'videoGallery');
  };

  // Add this useEffect to restore scroll position when component mounts
  useEffect(() => {
    const restoreScrollPosition = () => {
      const savedPosition = sessionStorage.getItem('scrollPosition');
      const lastSection = sessionStorage.getItem('lastSection');

      if (savedPosition && lastSection === 'videoGallery') {
        // Wait a bit for the page to fully load
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedPosition, 10));
          // Clear the saved position after restoring
          sessionStorage.removeItem('scrollPosition');
          sessionStorage.removeItem('lastSection');
        }, 100);
      }
    };

    restoreScrollPosition();
  }, []);

  useEffect(() => {
    const fetchChannelVideos = async () => {
      try {
        setLoading(true);
        setError(null);

        // Step 1: Get the channel's uploads playlist ID
        const channelRes = await fetch(
          `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${channelId}&key=${apiKey}`
        );

        if (!channelRes.ok) {
          throw new Error(`Failed to fetch channel: ${channelRes.status}`);
        }

        const channelData = await channelRes.json();

        if (!channelData.items || channelData.items.length === 0) {
          throw new Error("Channel not found");
        }

        // Get the uploads playlist ID
        const uploadsPlaylistId = channelData.items[0].contentDetails.relatedPlaylists.uploads;

        // Step 2: Get videos from the uploads playlist
        const playlistRes = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=6&playlistId=${uploadsPlaylistId}&key=${apiKey}&order=date`
        );

        if (!playlistRes.ok) {
          throw new Error(`Failed to fetch videos: ${playlistRes.status}`);
        }

        const playlistData = await playlistRes.json();
        setVideos(playlistData.items || []);

      } catch (error) {
        console.error("Error fetching videos:", error);
        setError("Failed to load videos. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchChannelVideos();
  }, [channelId, apiKey]);

  const handleReload = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <div className="media-header">
          <h2 className="gallery-title">Adv. Faiz Syed Official & Media</h2>
          <Link
            to="https://www.youtube.com/@AdvFaizSyedOfficial"
            target='_blank' // Changed to _blank for better UX
            rel='noopener noreferrer'
            className="activities-button"
            onClick={handleYouTubeClick}
          >
            Subscribe Here
          </Link>
        </div>
        <p className="gallery-subtitle">
          Browse our latest 6 videos from our YouTube channel.
        </p>

        {loading && (
          <div className="loading-message">Loading latest videos...</div>
        )}

        {error && (
          <div className="error-message">{error}</div>
        )}

        {!loading && !error && videos.length === 0 && (
          <div className="no-videos-message">No videos found on the channel.</div>
        )}

        {/* Video Grid */}
        <div className="gallery-grid">
          {videos.map((video, index) => (
            <div key={video.id || `video-${index}`} className="gallery-item">
              <iframe
                width="100%"
                height="200"
                src={`https://www.youtube.com/embed/${video.snippet.resourceId?.videoId || video.id}`}
                title={video.snippet.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
              {/* Optional: Show video title */}
              {/* <p className="image-caption">{video.snippet.title}</p> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoGallery;





// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import './BlogList.css';

// const VideoGallery = () => {
//   const [videos, setVideos] = useState([]);

//   // Replace with your playlist ID and API key
//   const playlistId = "PLOn2H_O-YC2dXaw7RW7UwKhPt9pkwjWlG";
//   const apiKey = "AIzaSyB7nGDTc061wCpnslx6MzzJO5mjcPkUAO8";


//   useEffect(() => {
//     const fetchVideos = async () => {
//       try {
//         const res = await fetch(
//           `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=6&playlistId=${playlistId}&key=${apiKey}`
//         );
//         const data = await res.json();
//         setVideos(data.items || []);
//       } catch (error) {
//         console.error("Error fetching videos:", error);
//       }
//     };

//     fetchVideos();
//   }, []);

//   const handleReload = () => {
//     window.scrollTo(0, 0);
//   };

//   return (
//     <section className="gallery-section">
//       <div className="gallery-container">
//         <div className="media-header">
//           <h2 className="gallery-title">Adv. Faiz Syed & Media</h2>
//           <Link
//             to="https://www.youtube.com/@AdvFaizSyedOfficial"
//             target='_parent'
//             className="activities-button"
//             onClick={handleReload}
//           >
//             Subscribe Here
//           </Link>
//         </div>
//         <p className="gallery-subtitle">
//           Browse our latest 6 lectures and videos from our YouTube channel.
//         </p>

//         {/* Video Grid */}
//         <div className="gallery-grid">
//           {videos.map((video) => (
//             <div key={video.id} className="gallery-item">
//               <iframe
//                 width="100%"
//                 height="200"
//                 src={`https://www.youtube.com/embed/${video.snippet.resourceId.videoId}`}
//                 title={video.snippet.title}
//                 frameBorder="0"
//                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                 allowFullScreen
//               ></iframe>
//               {/* <p className="image-caption">{video.snippet.title}</p> */}
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default VideoGallery;
